/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Defect_status = "ACCEPTED" | "IDENTIFIED" | "IN_REVIEW" | "REJECTED" | "RESOLVED" | "%future added value";
export type Inspection_status = "ARCHIVED" | "COMPLETED" | "DRAFT" | "IN_PROGRESS" | "%future added value";
export type Severity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Submission_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type CreateInspectionInput = {
    tourId: string;
    title: string;
    notes?: string | null;
    propertyAddress?: string | null;
    inspectorName?: string | null;
    inspectionDate?: unknown | null;
};
export type InspectionPanelCreateInspectionMutationVariables = {
    input: CreateInspectionInput;
};
export type InspectionPanelCreateInspectionMutationResponse = {
    readonly createInspection: {
        readonly inspection: {
            readonly id: string;
            readonly title: string;
            readonly inspectionStatus: Inspection_status;
            readonly inspectionDate: unknown;
            readonly propertyAddress: string;
            readonly inspectorName: string;
            readonly defects: ReadonlyArray<{
                readonly id: string;
                readonly title: string;
                readonly description: string;
                readonly severity: Severity;
                readonly defectStatus: Defect_status;
                readonly roomType: string;
                readonly defectCategory: string;
                readonly sourceClipIndex: number;
                readonly sourceFramePosition: string;
                readonly aiDetected: boolean;
                readonly aiConfidence: number;
                readonly evidenceImageURI: string;
                readonly audioStartSeconds: number;
                readonly audioEndSeconds: number;
            }>;
            readonly audioSubmissions: ReadonlyArray<{
                readonly id: string;
                readonly videoURI: string;
                readonly originalFilename: string;
                readonly submissionStatus: Submission_status;
                readonly rawTranscript: string;
                readonly durationSeconds: number;
                readonly errorMessage: string;
                readonly createdAt: unknown;
            }>;
        };
    };
};
export type InspectionPanelCreateInspectionMutation = {
    readonly response: InspectionPanelCreateInspectionMutationResponse;
    readonly variables: InspectionPanelCreateInspectionMutationVariables;
};



/*
mutation InspectionPanelCreateInspectionMutation(
  $input: CreateInspectionInput!
) {
  createInspection(input: $input) {
    inspection {
      id
      title
      inspectionStatus
      inspectionDate
      propertyAddress
      inspectorName
      defects {
        id
        title
        description
        severity
        defectStatus
        roomType
        defectCategory
        sourceClipIndex
        sourceFramePosition
        aiDetected
        aiConfidence
        evidenceImageURI
        audioStartSeconds
        audioEndSeconds
      }
      audioSubmissions {
        id
        videoURI
        originalFilename
        submissionStatus
        rawTranscript
        durationSeconds
        errorMessage
        createdAt
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateInspectionPayload",
    "kind": "LinkedField",
    "name": "createInspection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PropertyInspection",
        "kind": "LinkedField",
        "name": "inspection",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inspectionStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inspectionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "propertyAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inspectorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DefectItem",
            "kind": "LinkedField",
            "name": "defects",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "severity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defectStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roomType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defectCategory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceClipIndex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceFramePosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiDetected",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiConfidence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "evidenceImageURI",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioStartSeconds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioEndSeconds",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionAudioSubmission",
            "kind": "LinkedField",
            "name": "audioSubmissions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoURI",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalFilename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawTranscript",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationSeconds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelCreateInspectionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelCreateInspectionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0890a5fac56687ad30f74117f2a66bb6",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelCreateInspectionMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelCreateInspectionMutation(\n  $input: CreateInspectionInput!\n) {\n  createInspection(input: $input) {\n    inspection {\n      id\n      title\n      inspectionStatus\n      inspectionDate\n      propertyAddress\n      inspectorName\n      defects {\n        id\n        title\n        description\n        severity\n        defectStatus\n        roomType\n        defectCategory\n        sourceClipIndex\n        sourceFramePosition\n        aiDetected\n        aiConfidence\n        evidenceImageURI\n        audioStartSeconds\n        audioEndSeconds\n      }\n      audioSubmissions {\n        id\n        videoURI\n        originalFilename\n        submissionStatus\n        rawTranscript\n        durationSeconds\n        errorMessage\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '20c9d4c91f6376a91cf4953c9f30a7f7';
export default node;
